module.exports = __webpack_public_path__ + "static/media/35262d8b-761e-4d17-84a7-adc9f340ae5f.8f437dda.jpg";